import HeroTabs from "./hero-tabs";

export default function HeroDyanamicTabs(): void {
  HeroTabs();
  initTabScrollCentering();
}

function initTabScrollCentering(): void {
  const tabScrollContainers = document.querySelectorAll<HTMLDivElement>(".js-tab-scroll-container");

  if (!tabScrollContainers.length) return;

  tabScrollContainers.forEach((container) => {
    if (!container) return;

    container.addEventListener("click", (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target) return;

      const tabButton = target.closest<HTMLButtonElement>(".js-tab-btn");

      if (!tabButton) return;

      if (!container.offsetWidth || !tabButton.offsetWidth) return;

      const scrollLeft = tabButton.offsetLeft - (container.offsetWidth - tabButton.offsetWidth) / 2;

      container.scrollTo({
        left: scrollLeft,
        behavior: "smooth",
      });
    });
  });
}
